const initialStateUsers = {
    users: [],
    users_updated: false,
};

export default initialStateUsers;